import React, { useState, useEffect } from "react";
import TeamService from "services/TeamService";
import { useTimelineContext } from "store/contexts/timelineContext";
import Button from "components/CustomButton";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useToasts } from "react-toast-notifications";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import CustomInput from "components/CustomInput/CustomInput";
import Loader from "components/Loader";
import { Modal } from "react-responsive-modal";
import { ReactComponent as Edit } from "assets/img/icons/Edit.svg";

export default ({ team, todoList }) => {
  const [dialogState, setDialogState] = useState(false);
  const [loading, setLoading] = useState(false);
  const { updateTodo } = useTimelineContext();
  const { addToast } = useToasts();

  const formik = useFormik({
    initialValues: {
      list_name: todoList?.name,
    },
    validationSchema: Yup.object().shape({
      list_name: Yup.string()
        .min(4, "List name must be between 4 to 100 characters.")
        .max(100, "List name must be between 4 to 100 characters.")
        .required("Please enter the list name."),
    }),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        await TeamService.updateTodoList(team.id, todoList?.id, {
          name: values.list_name,
        });

        const todoListCopy = { ...todoList };

        todoListCopy.name = values.list_name;
        updateTodo(todoListCopy);
        formik.resetForm();

        setLoading(false);
        setDialogState(false);

        addToast("Your list has been updated successfully.", {
          appearance: "success",
        });
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (todoList) {
      formik.setValues({ list_name: todoList?.name });
    }

    //eslint-disable-next-line
  }, [todoList]);

  const closeDialog = () => {
    formik.resetForm();

    setDialogState(false);
  };

  return (
    <>
      <span className="icon-edit me-2" onClick={() => setDialogState(true)}>
        <Edit style={{ fill: "#a1a2a9", height: "20px" }} className="mw-20" />
      </span>
      <Modal
        open={dialogState}
        onClose={closeDialog}
        showCloseIcon={false}
        classNames={{
          modalContainer: "modalContainer",
          modal: "listModal",
        }}
      >
        <div className="listModalContent">
          <h5 className="text-center listModalHeader">Update List Name</h5>
          <Button type="button" buttonClass="btn-close">
            <CloseIcon onClick={closeDialog} />
          </Button>
          <form noValidate onSubmit={formik.handleSubmit}>
            <CustomInput
              formGroup={false}
              id={"add-members"}
              inputClass="full_w listInput"
              inputProps={{
                type: "text",
                ...formik.getFieldProps("list_name"),
                error: formik.errors.list_name,
              }}
            />
            <Button
              buttonClass="btn grad_btn full_w"
              name={!loading ? "Update Now" : <Loader width={40} height={40} />}
              disabled={loading && true}
            />
          </form>
        </div>
      </Modal>
    </>
  );
};
